module.exports = __webpack_public_path__ + "static/media/index.497f5ee2.mjs";


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/index.mjs
// module id = 443
// module chunks = 0